import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { RootState } from '../../store'
import { Bars3Icon } from '@heroicons/react/24/outline'
import LanguageSwitcher from '../common/LanguageSwitcher'

interface HeaderProps {
  onMenuToggle: () => void
}

export default function Header({ onMenuToggle }: HeaderProps) {
  const { user } = useSelector((s: RootState) => s.auth)
  const { totalActive } = useSelector((s: RootState) => s.vehicles)
  const initials = user ? (user.firstName?.[0] ?? '') + (user.lastName?.[0] ?? '') : '?'

  return (
    <header
      className="h-14 bg-white border-b border-gray-100 flex items-center gap-3 px-4 md:px-6 flex-shrink-0"
      role="banner"
    >
      <a href="#main-content" className="skip-link">Aller au contenu</a>

      {/* Hamburger — mobile */}
      <button
        onClick={onMenuToggle}
        className="lg:hidden -ml-1 p-2 rounded-xl text-gray-500 hover:text-gray-900 hover:bg-gray-100 transition-colors"
        aria-label="Ouvrir le menu de navigation"
      >
        <Bars3Icon className="h-5 w-5" aria-hidden="true" />
      </button>

      <div className="flex-1" />

      {/* Sélecteur de langue */}
      <LanguageSwitcher />

      {/* Active vehicles */}
      <div
        className="flex items-center gap-1.5 px-2.5 py-1.5 bg-green-50 border border-green-100 rounded-full"
        aria-label={`${totalActive} véhicules actifs`}
      >
        <span className="h-2 w-2 rounded-full bg-green-500 animate-pulse" aria-hidden="true" />
        <span className="text-xs font-semibold text-green-700 tabular-nums">{totalActive} actifs</span>
      </div>

      {/* User chip → Mon compte */}
      {user && (
        <Link
          to="/account"
          className="hidden sm:flex items-center gap-2 px-2.5 py-1.5 bg-surface-muted border border-surface-border rounded-full hover:bg-gray-100 transition-colors"
          aria-label={`Mon compte — ${user.firstName} ${user.lastName}`}
        >
          <div
            className="w-5 h-5 rounded-full bg-brand-600 flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
            aria-hidden="true"
          >
            {initials}
          </div>
          <span className="text-xs font-medium text-gray-700 max-w-[9rem] truncate">
            {user.firstName} {user.lastName}
          </span>
        </Link>
      )}
    </header>
  )
}
